import { useEffect, useState } from 'react';
import { MindMapNode } from '../types';

export const useMindMapEvents = (
  data: MindMapNode | null,
  selectedNodeId: string | undefined,
  lastAddedNodeId: string | null,
  onAddNode: (parentId: string) => void,
  onDeleteNode: (nodeId: string, cascade: 'cascade' | 'reparent') => void,
  onNodeAddedProcessed: () => void,
  setEditingId: (id: string | null) => void,
  setContextMenu: (menu: any) => void,
  setDeleteDialog: (dialog: any) => void,
  setDescDialog: (dialog: any) => void
) => {
  // New Node Handling
  useEffect(() => {
      if (lastAddedNodeId) {
          setEditingId(lastAddedNodeId);
          onNodeAddedProcessed();
      }
  }, [lastAddedNodeId, onNodeAddedProcessed]);

  const handleDeleteClick = (nodeId: string) => {
      const findNode = (node: MindMapNode): MindMapNode | undefined => {
          if (node.id === nodeId) return node;
          if (node.children) {
              for (const child of node.children) if (findNode(child)) return findNode(child);
          }
          return undefined;
      };
      const node = findNode(data as MindMapNode);
      if (node) {
          if (node.children && node.children.length > 0) {
              setDeleteDialog({ nodeId, nodeName: node.name, hasChildren: true });
          } else {
              onDeleteNode(nodeId, 'cascade');
          }
      }
      setContextMenu(null);
  };
  
  const handleEditDescription = (nodeId: string) => {
      const findNode = (node: MindMapNode): MindMapNode | undefined => {
          if (node.id === nodeId) return node;
          if (node.children) {
              for (const child of node.children) if (findNode(child)) return findNode(child);
          }
          return undefined;
      };
      const node = findNode(data as MindMapNode);
      if (node) {
          setDescDialog({ nodeId, initialDesc: node.description || "" });
      }
      setContextMenu(null);
  };

  useEffect(() => {
      const handleKeyDown = (e: KeyboardEvent) => {
          if ((e.target as HTMLElement).tagName === 'INPUT' || (e.target as HTMLElement).tagName === 'TEXTAREA') return;
          if (e.key === 'Tab' && !e.repeat) { 
              if (selectedNodeId) {
                  e.preventDefault(); e.stopPropagation();
                  onAddNode(selectedNodeId);
              }
          } else if (e.key === 'Delete') {
              if (selectedNodeId && selectedNodeId !== 'root') {
                  e.preventDefault();
                  handleDeleteClick(selectedNodeId);
              }
          } else if (e.key === 'Enter' && selectedNodeId) {
             e.preventDefault();
             setEditingId(selectedNodeId);
          }
      };
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedNodeId, onAddNode, data]); 

  return { handleDeleteClick, handleEditDescription };
};
